var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"el-icon-s-fold",on:{"click":_vm.ShowNav}}),_vm._v(" "),_c('i',{staticClass:"login-out",on:{"click":_vm.logout}},[_c('i',{staticClass:"el-icon-switch-button login-out-icon"}),_vm._v("\n      退出\n    ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ab7bb84","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBar.vue
// module id = null
// module chunks = 